export default {"src":"/_next/static/media/industrial-land-icon.dd451974.svg","height":104,"width":108,"blurWidth":0,"blurHeight":0};